import {
  GET_THONG_BAO,
  GET_THONG_BAO_SUCCESS,
  GET_THONG_BAO_FAILURE,
  UPDATE_THONG_BAO,
  UPDATE_THONG_BAO_SUCCESS,
  UPDATE_THONG_BAO_FAILURE,
  GET_LIST_THONG_BAO,
  GET_LIST_THONG_BAO_SUCCESS,
  GET_LIST_THONG_BAO_FAILURE,
  SHOW_THONG_BAO,
} from "actions/ThongBao/actionTypes";

const initialState = {
  getThongBaoLoading: false,
  objThongBao: {},
  objListThongBao: {},
  thuocTinhTaiSanLoaded: false,
  objThuocTinhTaiSan1: [],
  isShowThongBao: false,
};
const getListThongBao = (state, action) => ({
  ...state,
  getThongBaoLoading: true,
});

const getListThongBaoSuccess = (state, action) => {
  return {
    ...state,
    getThongBaoLoading: false,
    thuocTinhTaiSanLoaded: true,
    objListThongBao: action.payload,
  };
};

const getListThongBaoFailed = (state, action) => ({
  ...state,
  getListThongBaoLoading: false,
  objListThongBao: {},
});
const getThongBao = (state, action) => ({
  ...state,
  getThongBaoLoading: true,
});

const getThongBaoSuccess = (state, action) => {
  return {
    ...state,
    getThongBaoLoading: false,
    objThongBao: action.payload,
  };
};

const getThongBaoFailed = (state, action) => ({
  ...state,
  getThongBaoLoading: false,
  objThongBao: {},
});
const updateThongBao = (state, action) => ({
  ...state,
  updateThongBaoLoading: true,
  objUpdate: action.payload,
});

const updateThongBaoSuccess = (state, action) => {
  return {
    ...state,
    updateThongBaoLoading: false,
    objUpdate: {},
  };
};

const updateThongBaoFailed = (state, action) => ({
  ...state,
  updateThongBaoLoading: false,
  objUpdate: {},
});
const setShowThongBao = (state, action) => {
  return {
    ...state,
    isShowThongBao: !state.isShowThongBao,
  };
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_THONG_BAO:
      return getThongBao(state, action);
    case GET_THONG_BAO_SUCCESS:
      return getThongBaoSuccess(state, action);
    case GET_THONG_BAO_FAILURE:
      return getThongBaoFailed(state, action);
    case GET_LIST_THONG_BAO:
      return getListThongBao(state, action);
    case GET_LIST_THONG_BAO_SUCCESS:
      return getListThongBaoSuccess(state, action);
    case GET_LIST_THONG_BAO_FAILURE:
      return getListThongBaoFailed(state, action);
    case UPDATE_THONG_BAO:
      return updateThongBao(state, action);
    case UPDATE_THONG_BAO_SUCCESS:
      return updateThongBaoSuccess(state, action);
    case UPDATE_THONG_BAO_FAILURE:
      return updateThongBaoFailed(state, action);
    case SHOW_THONG_BAO:
      return setShowThongBao(state, action);
    default:
      return state;
  }
};

export default authReducer;
